import styled from 'styled-components'

type StyledProps = {
  type: 'default' | 'warning' | 'error'
}

const StyledActionDialog = styled.div<StyledProps>`
  padding: 20px;
  user-select: none;

  .dialog-header {
    display: flex;
    align-items: center;

    .dialog-message-icon {
      flex-shrink: 0;
      margin-right: 12px;
      height: 28px;
      width: 28px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${({ type, theme }) => `
        ${type === 'default' ? theme.color.gray[200] : ''}
        ${type === 'error' ? theme.color.red[200] : ''}
        ${type === 'warning' ? theme.color.amber[200] : ''}
      `};
      color: ${({ type, theme }) => `
        ${type === 'default' ? theme.color.gray[600] : ''}
        ${type === 'error' ? theme.color.red[900] : ''}
        ${type === 'warning' ? theme.color.amber[900] : ''}
      `};

      svg {
        height: 22px;
      }
    }

    .dialog-title {
      font-weight: 700;
      font-size: 17px;
      color: ${({ type, theme }) => `
        ${type === 'default' ? theme.color.gray[700] : ''}
        ${type === 'error' ? theme.color.red[800] : ''}
        ${type === 'warning' ? theme.color.amber[800] : ''}
      `};
    }
  }

  .dialog-message-container {
    margin-top: 12px;

    .dialog-body {
      line-height: 22px;
      margin-top: 3px;
      color: ${({ theme }) => theme.color.gray[600]};

      a {
        font-weight: 500;
        text-decoration: underline;
        border-radius: 2px;
        transition: 0.2s;
        color: ${({ theme }) => theme.color.brand};

        &:hover {
          box-shadow: 0 0 0 3px #e0f2fe;
          background-color: ${({ theme }) => theme.color.brandLight};
        }
      }
    }
  }

  .dialog-actions {
    margin-top: 28px;
    display: flex;

    button {
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background-color: transparent;
      padding: 0 18px;
      transition: 0.2s;
      border-radius: 4px;
      user-select: none;
      font-weight: 500;
      background-color: ${({ theme }) => theme.color.gray[100]};
      color: ${({ theme }) => theme.color.gray[600]};

      span {
        position: relative;
        top: 1px;
      }

      &:not(:last-child) {
        margin-right: 14px;
        flex-shrink: 0;
      }

      &:hover {
        cursor: pointer;
        background-color: ${({ theme }) => theme.color.gray[200]};
      }
    }

    .confirm-btn {
      width: 100%;
      background-color: ${({ type, theme }) => `
        ${type === 'default' ? theme.color.brand : ''}
        ${type === 'error' ? theme.color.red[800] : ''}
        ${type === 'warning' ? theme.color.amber[800] : ''}
      `};
      color: ${({ theme }) => theme.color.background};

      span {
        position: relative;
        top: 1px;
      }

      svg {
        height: 18px;
        margin-right: 8px;
      }

      &:hover {
        background-color: ${({ type, theme }) => `
          ${type === 'default' ? theme.color.brandDark : ''}
          ${type === 'error' ? theme.color.red[900] : ''}
          ${type === 'warning' ? theme.color.amber[900] : ''}
        `};
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    max-width: 300px;
    width: 100vw;
    padding: 28px;
  }
`

export default StyledActionDialog
